import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormField, FormFields, ListFields } from "@/types";

export function personalIdFields(hideCheckboxes: boolean = false): (FormField & { meta?: Record<string, any> })[] {
  return [
    {
      name: "photo_container",
      type: "photoContainer",
      value: [
        {
          name: "id_photo",
          type: "inputFile",
          label: $t("Front side of your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("id_photo"),
          },
        },
        {
          name: "id_photo_back",
          type: "inputFile",
          label: $t("Back side of your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("id_photo_back"),
          },
        },
        {
          name: "photo_with_id",
          type: "inputFile",
          label: $t("Selfie holding your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("photo_with_id"),
          },
        },
      ],
    },

    ...(config.featureNSFW && !hideCheckboxes
      ? [
          { name: "acknowledgeAgreement", type: "checkbox" },
          { name: "sensitiveContent", type: "checkbox" },
        ]
      : []),
  ];
}

export function personalInfoFields(): FormFields {
  return [
    {
      name: "firstName",
      label: $t("Legal first name"),
      placeholder: $t("Martin"),
      rules: ["required"],
      validationMode: "aggressive",
    },
    {
      name: "middleName",
      label: $t("Legal middle name (optional)"),
      placeholder: $t("Robert"),
    },
    {
      name: "lastName",
      label: $t("Legal last name"),
      placeholder: $t("Botosh"),
      rules: ["required"],
      validationMode: "aggressive",
    },
    {
      name: "dateOfBirth",
      type: "date",
      label: $t("Date of birth"),
      min: new Date(1900, 0),
      max: new Date(),
      rules: ["required"],
      validationMode: "aggressive",
    },
    {
      name: "phone",
      label: $t("Phone number"),
      rules: ["required"],
      type: "phone",
      validationMode: "aggressive",
    },
    ...(config.featureSmsNotifications
      ? [
          {
            name: "smsNotifications",
            label: $t("Receive SMS notifications"),
            type: "checkbox",
          },
        ]
      : []),
  ];
}

export const languageList: ListFields = [
  {
    text: $t("English"),
    value: "en",
  },
  {
    text: $t("Chinese"),
    value: "zh",
  },
  {
    text: $t("Spanish"),
    value: "es",
  },
  {
    text: $t("Arabic"),
    value: "ar",
  },
  {
    text: $t("French"),
    value: "fr",
  },
  {
    text: $t("Russian"),
    value: "ru",
  },
  {
    text: $t("Portuguese"),
    value: "pt",
  },
  {
    text: $t("German"),
    value: "de",
  },
  {
    text: $t("Japanese"),
    value: "ja",
  },
  {
    text: $t("Hindi"),
    value: "hi",
  },
  {
    text: $t("Bengali"),
    value: "bn",
  },
  {
    text: $t("Urdu"),
    value: "ur",
  },
  {
    text: $t("Korean"),
    value: "ko",
  },
  {
    text: $t("Italian"),
    value: "it",
  },
  {
    text: $t("Turkish"),
    value: "tr",
  },
  {
    text: $t("Vietnamese"),
    value: "vi",
  },
  {
    text: $t("Tamil"),
    value: "ta",
  },
  {
    text: $t("Greek"),
    value: "gr",
  },
  {
    text: $t("Dutch"),
    value: "nl",
  },
  {
    text: $t("Swedish"),
    value: "sv",
  },
  {
    text: $t("Afrikaans"),
    value: "af",
  },
  {
    text: $t("Hebrew"),
    value: "he",
  },
  {
    text: $t("Thai"),
    value: "th",
  },
];
